import { injectGlobal } from 'react-emotion'
import { colours } from './colours'

const { primary, danger } = colours

injectGlobal`
  img {
    display: block;
    margin: 0;
  }
  a {
    font-weight: 700;
    color: ${primary};
    text-decoration: none;
    &:hover {
      color: ${danger};
      text-decoration: none;
    }
  }
`
